import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export type ServiceName = string | null

export const useServiceName = (): ServiceName => {
  const { pathname } = useLocation()

  const [name, setName] = useState<ServiceName>(null)

  useEffect(() => {
    const getService = () => {
      switch (pathname) {
        case '/':
          return setName('Übersicht')
        case '/dashboard':
          return setName('Dashboard')
        case '/notifications':
          return setName('Exporte')
        case '/io':
          return setName('Benachrichtigungen')
        case '/folder':
          return setName('Gebäude')
        case '/sensors':
          return setName('Sensoren')
        case '/news':
          return setName('News')
        case '/users':
          return setName('Benutzer')
        default:
          return setName(null)
      }
    }

    getService()
  }, [pathname])

  return name
}
